import localizedDateUtils from './localizedDateUtils';

export const dateUtils = localizedDateUtils;